import { createContext, useContext, useEffect } from 'react';

// GatewayLayout pins the admin's "Back to my account" button top-right. Pages
// that want a language switcher ask for it here, so both share that toolbar
// instead of overlapping.
export const GatewayLanguageMenuContext = createContext<
  (show: boolean) => void
>(() => undefined);

export const useGatewayLanguageMenu = () => {
  const setShow = useContext(GatewayLanguageMenuContext);
  useEffect(() => {
    setShow(true);
    return () => setShow(false);
  }, [setShow]);
};
